import { CombinedStateCreator } from "../store";

export interface DialogStore {
  upgradeDialog: {
    isOpen: boolean;
    openDialog: () => void;
    closeDialog: () => void;
  };
  coachAppDialog: {
    isOpen: boolean;
    hasUnread: boolean;
    openDialog: () => void;
    closeDialog: () => void;
    markAsSeen: () => void;
    setUnread: () => void;
  };
}

export const createDialogStore: CombinedStateCreator<DialogStore> = (
  set,
  get
) => ({
  upgradeDialog: {
    isOpen: false,
    openDialog: () => {
      set((state) => {
        state.upgradeDialog.isOpen = true;
      });
    },
    closeDialog: () => {
      set((state) => {
        state.upgradeDialog.isOpen = false;
      });
    },
  },
  coachAppDialog: {
    isOpen: false,
    hasUnread: true,
    openDialog: () => {
      set((state) => {
        state.coachAppDialog.isOpen = true;
        state.coachAppDialog.hasUnread = false;
      });
    },
    closeDialog: () => {
      set((state) => {
        state.coachAppDialog.isOpen = false;
      });
    },
    markAsSeen: () => {
      set((state) => {
        state.coachAppDialog.hasUnread = false;
      });
    },
    setUnread: () => {
      set((state) => {
        state.coachAppDialog.hasUnread = true;
      });
    },
  },
});
